console.log('=== HERO DOCK SCRIPT LOADED ===');

function initHeroDock(hero, prose) {
  console.log('--- initHeroDock called ---');
  console.log('Hero:', hero);
  console.log('Prose:', prose);

  console.log('Window width:', window.innerWidth);

  if (window.innerWidth < 1000) {
    console.log('Blocked by desktop width rule');
    return;
  }

  const OFFSET = 30;

  const heroPosition = getComputedStyle(hero).position;
  console.log('Hero computed position:', heroPosition);

  if (heroPosition === 'static') {
    hero.style.position = 'relative';
    console.log('Hero position set to relative');
  }

  function update() {
    const heroRect = hero.getBoundingClientRect();
    const vh = window.innerHeight;

    console.log('--- update firing ---');
    console.log('Hero rect:', heroRect);
    console.log('Viewport height:', vh);

    if (heroRect.bottom > vh) {
      console.log('Dock condition TRUE → applying fixed styles');

      prose.style.position = 'fixed';
      prose.style.bottom = OFFSET + 'px';
      prose.style.top = 'auto';
      prose.style.minWidth = '320px';
      prose.style.zIndex = '10';
      prose.style.left = heroRect.left + heroRect.width / 2 + 'px';
      prose.style.transform = 'translateX(-50%)';

      console.log('Fixed styles applied');
    } else {
      console.log('Dock condition FALSE → restoring absolute');

      prose.style.position = 'absolute';
      prose.style.bottom = OFFSET + 'px';
      prose.style.top = '';
      prose.style.minWidth = '320px';
      prose.style.zIndex = '';
      prose.style.left = '50%';
      prose.style.transform = 'translateX(-50%)';

      console.log('Absolute styles restored');
    }
  }

  console.log('Attaching scroll + resize listeners');
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  update();
}

function scanForDockSections() {
  console.log('=== SCANNING FOR DOCK SECTIONS ===');

  const hero = document.querySelector('[class*="ai-video-container-"]');
  const prose = document.querySelector('[class*="ai-video-content-"]');

  console.log('Hero found:', hero);
  console.log('Prose found:', prose);

  if (!hero || !prose) {
    console.log('Hero or Prose not found, skipping');
    return;
  }

  if (hero.dataset.heroDockInit) {
    console.log('Already initialized, skipping');
    return;
  }

  hero.dataset.heroDockInit = 'true';
  initHeroDock(hero, prose);
}

scanForDockSections();
setTimeout(scanForDockSections, 500);
setTimeout(scanForDockSections, 1000);
setTimeout(scanForDockSections, 2000);
setTimeout(scanForDockSections, 3000);